const truncateString = (string) => {
  return string.length > 21 ? `${string.substring(0, 25)}...` : string;
};

export default truncateString;
